import Joi from '@hapi/joi'

export const LoftAmendmentsReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Please select valid Factory`,
        "any.required": `Factory required`
    }),
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date"),
    collectionPointID: Joi.number().allow("").label("CollectionPoint").messages({
        
    }),
}